<template>
  <div :class="$style.container">
    <div :class="$style.carusel">
      <telegram-information-panel
        v-if="!isBotSigned"
      ></telegram-information-panel>
      <widget-information-panel></widget-information-panel>
      <report-information-panel></report-information-panel>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import MerchantService from 'services/merchant';

import TelegramInformationPanel from 'atoms/InformationPanels/TelegramInformationPanel';
import WidgetInformationPanel from 'atoms/InformationPanels/WidgetInformationPanel';
import ReportInformationPanel from 'atoms/InformationPanels/ReportInformationPanel';

export default {
  name: 'FunctionalBannersCarusel',
  components: {
    ReportInformationPanel,
    TelegramInformationPanel,
    WidgetInformationPanel,
  },
  computed: {
    isBotSigned() {
      return MerchantService.checkBotSigned(this.MERCHANT_INFO);
    },
    ...mapState([
      'MERCHANT_INFO',
    ]),
  },
};
</script>

<style lang="sass" module>
  .container
    position: relative

  .carusel
    display: grid
    grid-template-columns: 50vw 50vw 50vw
    grid-gap: 20px
    padding: 0 20px
    overflow-x: scroll
</style>
